<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        Revenue
      </h5>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <div v-else class="panel-body text-center">
            <span style="font-size: 48px">
                {{ revenue | price }}
            </span>

      <br>

      <span style="font-size: 18px">
                <span v-if="target">
                    Target: {{ target | price }}
                </span>
                
                <span v-else>
                    &nbsp;
                </span>
            </span>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SaveHeight from '@/mixins/SaveHeight'

export default {
  components: {LoadingSpinner},

  mixins: [SaveHeight],

  props: ['year', 'portal', 'targetMetric', 'user'],

  data() {
    return {
      loading: true,
      revenue: null,
      target: null
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    year() {
      this.load()
    },

    targetMetric() {
      this.load()
    },

    portal() {
      this.load()
    },

    user() {
      this.load()
    }
  },

  computed: {
    filters() {
      return [
        {dimension: 'publish_year', operator: '=', value: this.year},
        {dimension: 'portal_id', operator: '=', value: this.portal.id}
      ]
    },

    filtersWithUser() {
      if (!this.user) {
        return this.filters
      }

      return this.filters.concat({dimension: 'user_id', operator: '=', value: this.user})
    }
  },

  methods: {
    load() {
      this.saveHeight()

      this.loading = true

      Promise.all([
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: 'ad_value_after_costs'},
          ],
          filters: this.filtersWithUser
        }),
        http.post('/api/v1/reports/new-analytics', {
          metrics: [
            {name: this.targetMetric},
          ],
          filters: this.filters
        })
      ]).then(responses => {
        this.revenue = responses[0].data.data[0].ad_value_after_costs

        this.target = responses[1].data.data[0][this.targetMetric]

        this.loading = false
      })
    }
  }
}
</script>
